import { Modal } from '@thefarmersfront/kitchen';

import { RETURN_INVOICE_GUIDE } from '~/constants';

import guideImage from '~/assets/images/returnInvoiceGuide.png';

import styles from './ReceiveReturnDisposalReturnInvoiceGuideModal.module.scss';

type TypeReceiveReturnDisposalReturnInvoiceGuideModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

/**
 * [입고관리 > 회송/폐기 관리] 회수(택배) - 반송장 작성 가이드 모달
 *
 * @note 회수(택배) 신청 모달의 [반송장 작성 가이드] 버튼으로 진입하는 정적 안내 모달.
 *       주의사항·송장 예시·4단계 작성 가이드는 Figma 도안을 그대로 반영한 단일 이미지로 노출한다.
 */
const ReceiveReturnDisposalReturnInvoiceGuideModal = ({
  isOpen,
  onClose,
}: TypeReceiveReturnDisposalReturnInvoiceGuideModalProps) => {
  return (
    <Modal title={RETURN_INVOICE_GUIDE.TITLE} size="xlarge" open={isOpen} onConfirm={onClose}>
      <div className={styles['guide-body']}>
        <img className={styles['guide-image']} src={guideImage} alt="반송장 작성 가이드" />
      </div>
    </Modal>
  );
};

export default ReceiveReturnDisposalReturnInvoiceGuideModal;
